import React from "react";
import { useSearchParams } from "react-router-dom";
import { CreateZoneStage1Page } from "./stage1";
import { CreateZoneStage2Page } from "./stage2";
import { VARIANT_NO_FLY } from "../../zones-page/types";

export const NoFlyCreateZonePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const stage = searchParams.get("stage");

  return (
    <>
      {stage === "2" ? (
        <CreateZoneStage2Page />
      ) : (
        <CreateZoneStage1Page variant={VARIANT_NO_FLY} />
      )}
    </>
  );
};
